const IMAGES_URL = 'https://images.vaults.fyi'

type ImagePath = 'networks' | 'protocols' | 'tokens' | 'curators'

export const getImageUrl = (path: ImagePath, name: string) => `${IMAGES_URL}/${path}/${name}.png`
